import React from 'react'
import cx from 'classnames'
import BlockContent from '@sanity/block-content-to-react'

import META from '@/meta.js'
import Footer from '@/footer.js'
import ComingSoon from '@/modules/comingSoon.js'

const Page = ({ transitionStatus, entry, exit, pageContext }) => {
  const {
    title,
    content
  } = pageContext.data
  const {
    data
  } = pageContext
  const metaData = {
    title: data.metaInfo ? data.metaInfo.metaTitle || `${data.title} - re:store` : `${data.title} - re:store`,
    keywords: data.metaInfo ? data.metaInfo.keywords || '' : '',
    description: data.metaInfo ? data.metaInfo.description || data.description : data.description,
    url: `/${data.slug.current}`,
    image: data.image,
    ogTitle: data.metaInfo ? data.metaInfo.title || `${data.title} - re:store` : `${data.title} - re:store`,
    ogDescription: data.metaInfo ? data.metaInfo.openGraphDescription || data.description : data.description,
    ogImage: data.metaInfo ? data.metaInfo.openImage || data.image : data.image,
    twitterImage: data.metaInfo ? data.metaInfo.twitterImage || data.image : data.image,
    twitterTitle: data.metaInfo ? data.metaInfo.twitterTitle || `${data.title} - re:store` : `${data.title} - re:store`,
    twitterDescription: data.metaInfo ? data.metaInfo.twitterDescription || data.description : data.description
  }
  return (
    <div className={cx('animate__page', transitionStatus)}>
      <META metaData={metaData} />
      <div className='nav--spacer' />
      <div className='container--l mxa x p15'>
        <div class='x ac'>
          <h1>{title}</h1>
        </div>
        <div>
          <BlockContent blocks={content} />
        </div>
      </div>
      <ComingSoon />
      <Footer />
    </div>
  )
}

export default Page